import React, { useState } from 'react';

const CommitVersionModal = ({ isOpen, onClose, onCommit, sheetTitle }) => {
  const [commitMessage, setCommitMessage] = useState('');
  const [isCommitting, setIsCommitting] = useState(false);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!commitMessage.trim()) {
      return; // Don't commit without a message
    }

    setIsCommitting(true);
    try {
      await onCommit(commitMessage.trim());
      onClose();
      setCommitMessage('');
    } catch (error) {
      console.error('Error committing version:', error);
      // Keep modal open on error
    } finally {
      setIsCommitting(false);
    }
  };

  const handleClose = () => {
    if (!isCommitting) {
      onClose();
      setCommitMessage('');
    }
  };

  return (
    <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-md">
        <h3 className="text-lg font-medium text-gray-900 mb-4">
          Commit Version
        </h3>
        
        <p className="text-sm text-gray-700 mb-4">
          Create a new version of "{sheetTitle}" with your current changes.
        </p>
        
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="commitMessage" className="block text-sm font-medium text-gray-700 mb-2">
              Commit Message *
            </label>
            <textarea
              id="commitMessage"
              value={commitMessage}
              onChange={(e) => setCommitMessage(e.target.value)}
              placeholder="Describe what changed in this version..."
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
              rows={3}
              disabled={isCommitting}
              required
            />
          </div>
          
          <div className="bg-gray-50 p-3 rounded-md mb-4">
            <h4 className="text-sm font-medium text-gray-700 mb-2">Changes to commit:</h4>
            <ul className="text-sm text-gray-600 space-y-1">
              <li>• Current sheet modifications</li>
              <li>• Updated song information</li>
              <li>• Section and part changes</li>
            </ul>
          </div>
          
          <div className="flex justify-end space-x-3">
            <button
              type="button"
              onClick={handleClose}
              disabled={isCommitting}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-gray-300 rounded-md hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={!commitMessage.trim() || isCommitting}
              className="px-4 py-2 text-sm font-medium text-white bg-indigo-600 border border-transparent rounded-md hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {isCommitting ? 'Committing...' : 'Commit Version'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CommitVersionModal;